const ITEMS = [
  "Venta de Empresas",
  "Intermediación M&A",
  "Valoración de Empresas",
  "Búsqueda de Compradores",
  "Negociación y Cierre",
  "Consultoría Financiera",
  "Estructura de Capital",
  "Confidencialidad Absoluta",
];

const Row = ({ hidden }) => (
  <div aria-hidden={hidden} className="flex shrink-0 items-center">
    {ITEMS.map((t) => (
      <span key={t} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-serif text-xl italic text-gold/90 md:px-12 md:text-2xl">{t}</span>
        <span className="h-1.5 w-1.5 rotate-45 bg-gold/60" />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <section data-testid="marquee" className="marquee-hover relative overflow-hidden border-y border-gold/15 bg-ink-2 py-6">
      <div className="flex w-max animate-marquee">
        <Row hidden={false} />
        <Row hidden={true} />
      </div>
    </section>
  );
}
